import {
  Box,
  Container,
  Hidden,
  IconButton,
  makeStyles,
} from '@material-ui/core';
import {Menu as MenuIcon} from '@material-ui/icons';
import Logo from 'components/Logo';
import React from 'react';
import {rieltor} from '../../../styles/theme';
import Balance from '../Balance';
import HeaderAvatar from '../HeaderAvatar';
import {useMobileMenu} from '../hooks';
import SideNavigation from '../SideNavigation';
import {WalletPlus} from '../../../components/Icons';
import RouterLink from '../../common/RouterLink';

export const useStyles = makeStyles(theme => ({
  headerContainerWrapper: {
    background: rieltor.mainGradient,
  },
  headerContainer: {
    padding: `10px 16px`,
  },
  headerContainerInner: {
    display: 'flex',
    flexFlow: 'row nowrap',
    columnGap: '40px',
    [theme.breakpoints.down('sm')]: {
      columnGap: 0,
    }
  },
  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexGrow: 1,
    [theme.breakpoints.down('xs')]: {
      flexGrow: 0,
    },
  },
  navButton: {
    color: '#fff',
    padding: '8px',
    '& .MuiIconButton-label': {
      display: 'flex',
      flexFlow: 'column nowrap',
      rowGap: '4px',
    },
    '& .MuiIconButton-root': {
    }
  },
  navButtonText: {
    fontSize: '14px',
  },
  logoWrapper: {
    columnGap: '16px',
    [theme.breakpoints.down('xs')]: {
      flexGrow: 1,
      justifyContent: 'center',
    }
  },
}));

const Header = () => {
  const classes = useStyles();

  const [, open] = useMobileMenu();

  return (
    <>
      <Box className={classes.headerContainerWrapper} display="flex">
        <Container className={classes.headerContainer} maxWidth="xl">
          <Box className={classes.headerContainerInner}>
            <Hidden mdUp>
              <IconButton
                className={classes.navButton}
                onClick={open}
              >
                <MenuIcon/>
              </IconButton>
            </Hidden>

            <Box display={'flex'} alignItems={'center'} className={classes.logoWrapper}>
              <Logo logoType={'big'}/>

              <Hidden smDown>
                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="19" viewBox="0 0 85 19" fill="none">
                  <path
                    d="M38.2866 1.18572L37.494 0.222656C37.2099 0.461292 36.8661 0.61186 36.4627 0.67436C36.0593 0.731178 35.5934 0.756746 35.065 0.751064C34.5366 0.739701 33.9485 0.745383 33.3008 0.76811C31.2951 0.836292 29.8093 1.64027 28.8434 3.18004C27.8775 4.71981 27.3945 7.01527 27.3945 10.0664V11.4386C27.3945 12.9727 27.6275 14.2653 28.0934 15.3164C28.565 16.3619 29.2269 17.1545 30.0792 17.6942C30.9371 18.2283 31.9371 18.4954 33.0792 18.4954C34.2156 18.4954 35.207 18.2255 36.0536 17.6857C36.9002 17.146 37.5593 16.3817 38.0309 15.3931C38.5025 14.3988 38.7383 13.2312 38.7383 11.8903C38.7383 10.5323 38.5025 9.38175 38.0309 8.43857C37.565 7.4897 36.9286 6.77095 36.1218 6.28232C35.3207 5.788 34.4173 5.54084 33.4116 5.54084C32.4514 5.54084 31.5707 5.77379 30.7695 6.2397C29.9741 6.70561 29.3576 7.38459 28.9201 8.27663H28.7496C28.8349 6.99822 29.0451 5.91584 29.3803 5.02947C29.7212 4.13743 30.2184 3.45561 30.8718 2.98402C31.5252 2.50675 32.3576 2.24254 33.369 2.19141C34.0735 2.15732 34.7298 2.13175 35.3377 2.1147C35.9514 2.09766 36.5053 2.02663 36.9996 1.90163C37.4996 1.77095 37.9286 1.53231 38.2866 1.18572ZM35.2781 16.467C34.6587 16.8931 33.9258 17.1062 33.0792 17.1062C31.7894 17.1062 30.7724 16.6488 30.0281 15.734C29.2894 14.8136 28.9201 13.5607 28.9201 11.9755C28.9258 11.2425 29.0252 10.5692 29.2184 9.95561C29.4116 9.34197 29.69 8.80788 30.0536 8.35334C30.4173 7.89879 30.8548 7.54936 31.3661 7.30504C31.8832 7.05504 32.4656 6.93004 33.1133 6.93004C33.9371 6.93004 34.6559 7.12606 35.2695 7.51811C35.8832 7.91016 36.3604 8.4755 36.7013 9.21413C37.0479 9.95277 37.2212 10.8448 37.2212 11.8903C37.2212 12.9414 37.0508 13.859 36.7099 14.6431C36.3746 15.4272 35.8974 16.0352 35.2781 16.467ZM42.0767 18.2229V5.13201H43.6023V18.2229H42.0767ZM42.8523 2.88201C42.5398 2.88201 42.2727 2.7769 42.0511 2.56667C41.8295 2.35076 41.7188 2.09224 41.7188 1.7911C41.7188 1.48997 41.8295 1.23429 42.0511 1.02406C42.2727 0.80815 42.5398 0.700195 42.8523 0.700195C43.1648 0.700195 43.4318 0.80815 43.6534 1.02406C43.875 1.23429 43.9858 1.48997 43.9858 1.7911C43.9858 2.09224 43.875 2.35076 43.6534 2.56667C43.4318 2.7769 43.1648 2.88201 42.8523 2.88201ZM66.8995 18.4957C65.6779 18.4957 64.6211 18.2116 63.729 17.6435C62.837 17.0696 62.1467 16.277 61.658 15.2656C61.1751 14.2486 60.9336 13.0781 60.9336 11.7543C60.9336 10.4361 61.1751 9.26562 61.658 8.2429C62.1467 7.21449 62.82 6.41051 63.6779 5.83097C64.5415 5.24574 65.5387 4.95312 66.6694 4.95312C67.3796 4.95312 68.0643 5.08381 68.7234 5.34517C69.3825 5.60085 69.9734 5.99574 70.4961 6.52983C71.0245 7.05824 71.4421 7.72585 71.7489 8.53267C72.0558 9.33381 72.2092 10.2827 72.2092 11.3793V12.1293H62.4611C62.4815 13.0912 62.6598 13.9378 62.9961 14.669C63.3597 15.4418 63.8739 16.0412 64.5387 16.4673C65.2035 16.8935 65.9904 17.1065 66.8995 17.1065C67.5188 17.1065 68.0614 17.0099 68.5273 16.8168C68.9989 16.6236 69.3938 16.3651 69.712 16.0412C70.0359 15.7116 70.2802 15.3509 70.445 14.9588L71.8853 15.4276C71.6864 15.9787 71.3597 16.4872 70.9052 16.9531C70.4563 17.419 69.8938 17.794 69.2177 18.0781C68.5472 18.3565 67.7745 18.4957 66.8995 18.4957ZM62.9961 8.75426C62.6918 9.38238 62.5169 10.0614 62.4711 10.7912H70.658C70.658 9.95028 70.4876 9.1946 70.1467 8.52415C69.8114 7.84801 69.3427 7.31392 68.7404 6.92188C68.1438 6.52983 67.4535 6.33381 66.6694 6.33381C65.8398 6.33381 65.1097 6.5554 64.479 6.99858C63.8484 7.44176 63.354 8.02699 62.9961 8.75426ZM74.2822 6.56365V5.13184H84.5095V6.56365H80.18V18.2227H78.6629V6.56365H74.2822ZM56.0518 10.9699V5.13184H57.5688V18.2227H56.0518V12.4017H49.1313V18.2227H47.6143V5.13184H49.1313V10.9699H56.0518ZM18.3645 18.5213C17.5748 18.5213 16.8532 18.3679 16.1998 18.0611C15.5463 17.7486 15.0265 17.2997 14.6401 16.7145C14.2537 16.1236 14.0605 15.4077 14.0605 14.5668C14.0605 13.919 14.1827 13.3736 14.427 12.9304C14.6713 12.4872 15.0179 12.1236 15.4668 11.8395C15.9157 11.5554 16.4469 11.331 17.0605 11.1662C17.6742 11.0014 18.3503 10.8736 19.089 10.7827C19.8219 10.6918 20.4412 10.6122 20.9469 10.544C21.4583 10.4759 21.8475 10.3679 22.1145 10.2202C22.3816 10.0724 22.5151 9.83381 22.5151 9.50426V9.19744C22.5151 8.3054 22.248 7.60369 21.714 7.09233C21.1855 6.57528 20.4242 6.31676 19.4299 6.31676C18.4867 6.31676 17.7168 6.52415 17.1202 6.93892C16.5293 7.35369 16.1145 7.84233 15.8759 8.40483L14.4355 7.88494C14.731 7.16903 15.1401 6.59801 15.6628 6.17188C16.1855 5.74006 16.7708 5.4304 17.4185 5.2429C18.0662 5.04972 18.7225 4.95312 19.3873 4.95312C19.8873 4.95312 20.4071 5.01847 20.9469 5.14915C21.4924 5.27983 21.998 5.5071 22.464 5.83097C22.9299 6.14915 23.3077 6.59517 23.5975 7.16903C23.8873 7.73722 24.0321 8.45881 24.0321 9.33381V18.223H22.5151V16.152H22.4213C22.2395 16.5384 21.9696 16.9134 21.6117 17.277C21.2537 17.6406 20.8049 17.9389 20.2651 18.1719C19.7253 18.4048 19.0918 18.5213 18.3645 18.5213ZM18.5691 17.1321C19.3759 17.1321 20.0748 16.9531 20.6657 16.5952C21.2566 16.2372 21.7111 15.7628 22.0293 15.1719C22.3532 14.5753 22.5151 13.919 22.5151 13.2031V11.3111C22.4015 11.419 22.2111 11.5156 21.9441 11.6009C21.6827 11.6861 21.3787 11.7628 21.0321 11.831C20.6912 11.8935 20.3503 11.9474 20.0094 11.9929C19.6685 12.0384 19.3617 12.0781 19.089 12.1122C18.3503 12.2031 17.7196 12.3452 17.1969 12.5384C16.6742 12.7315 16.2736 12.9986 15.9952 13.3395C15.7168 13.6747 15.5776 14.1065 15.5776 14.6349C15.5776 15.4304 15.8617 16.0469 16.4299 16.4844C16.998 16.9162 17.7111 17.1321 18.5691 17.1321ZM4.10795 9.99015L10.1165 18.2231H12.0256L5.02841 8.63503L11.4972 0.768555H9.60511L3.17045 8.56685H1.59375V0.768555H0V18.2231H1.59375V9.99015H4.10795Z"
                    fill="white"
                  />
                </svg>
              </Hidden>
            </Box>

            <div className={classes.controls}>
              <Hidden smDown>
                <Balance/>
              </Hidden>

              <Hidden mdUp>
                <RouterLink to={'/payment'} style={{display: 'flex', textDecoration: 'none'}}>
                  <IconButton
                    className={classes.navButton}
                  >
                    <WalletPlus/>
                  </IconButton>
                </RouterLink>
              </Hidden>
            </div>

            <Hidden xsDown>
              <HeaderAvatar/>
            </Hidden>
          </Box>
        </Container>
      </Box>

      <SideNavigation/>
    </>
  );
};

export default Header;
